"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.labels = void 0;
var labels = {
  he: {
    title: 'מה לבקש מהמזכירות',
    request: 'עדכון מצבת התלמידים והמורים, וסנכרון הנתונים עם הנמ"מ.',
    steps: 'שלבי הפעולה:',
    step1: 'לבצע שיוך עצמי של הכיתות והקבוצות שלך במערכת הניהול הפדגוגי של בית הספר (משו”ב, סמארטסקול ועוד).',
    step2: 'לייצא דוח מעודכן למשרד החינוך.',
    step3: 'אם היו שגויים בתהליך היצוא, משרד החינוך ישלח למזכירות דו"ח שגויים ויש לתקן את הנדרש.',
    step4: 'אם היו תיקונים  יש לייצא שוב את הדוח למשרד החינוך.',
    step5: 'כשלושה ימים לאחר השלמת הפעולה הנתונים יתעדכנו כאן ויהיה ניתן ליצור סביבת לימוד משותפת לך ולתלמידים שלך.',
    helpStart: 'ניתן לפנות',
    helpSupport: 'לתמיכה הטכנית שלנו',
    helpEnd: 'לעזרה ולהכוונה.',
    explanation: 'הסבר: איך מבצעים יבוא נמ”מ?'
  },
  ar: {
    title: 'المطلوب من السكرتاريّة',
    request: 'تحديث حالة التلاميذ والمعلمين، ومزامنة البيانات مع منظومة إدارة المستخدمين.',
    steps: 'مراحل العمل:',
    step1: 'القيام بإضافة ذاتيّة للصوف والمجموعات الخاصة بك في نظام الإدارة التربوية للمدرسة (משו"ב، Smartscool, الخ).',
    step2: 'إنتاج تقرير محتلن لصالح وزارة التربية والتعليم.',
    step3: 'إذا كانت هناك أخطاء في عملية إنتاج التقرير، فسترسل وزارة التربية والتعليم إلى سكرتاريّة المدرسة تقريرًا بالأخطاء ويجب تصحيح المطلوب.',
    step4: 'إذا كانت هناك تصليحاتيجب إعادة إنتاج التقرير لوزارة التربية  والتعليم.',
    step5: 'بعد حوالي ثلاثة أيام من اكتمال العملية، سيتم تحديث البيانات هنا وسيكون من الممكن إنشاء بيئة تعليمية مشتركة لك ولتلاميذك.',
    helpStart: 'يمكنك التوجّه',
    helpSupport: 'إلى الدعم الفنّيّ',
    helpEnd: 'لدينا للمساعدة والتوجيه.',
    explanation: 'شرح: كيف  نقوم بإحضار تقرير منظومة إدارة المستخدمين؟'
  },
  en: {
    title: 'מה לבקש מהמזכירות',
    request: 'עדכון מצבת התלמידים והמורים, וסנכרון הנתונים עם הנמ"מ.',
    steps: 'שלבי הפעולה:',
    step1: 'לבצע שיוך עצמי של הכיתות והקבוצות שלך במערכת הניהול הפדגוגי של בית הספר (משו”ב, סמארטסקול ועוד).',
    step2: 'לייצא דוח מעודכן למשרד החינוך.',
    step3: 'אם היו שגויים בתהליך היצוא, משרד החינוך ישלח למזכירות דו"ח שגויים ויש לתקן את הנדרש.',
    step4: 'אם היו תיקונים  יש לייצא שוב את הדוח למשרד החינוך.',
    step5: 'כשלושה ימים לאחר השלמת הפעולה הנתונים יתעדכנו כאן ויהיה ניתן ליצור סביבת לימוד משותפת לך ולתלמידים שלך.',
    helpStart: 'ניתן לפנות',
    helpSupport: 'לתמיכה הטכנית שלנו',
    helpEnd: 'לעזרה ולהכוונה.',
    explanation: 'הסבר: איך מבצעים יבוא נמ”מ?'
  }
};
exports.labels = labels;